import EventsPage from '../../components/EventsPage';

export default function GuardhouseEvents() {
  return <EventsPage />;
}
